import { render, staticRenderFns } from "./builder.vue?vue&type=template&id=2094e240&scoped=true"
import script from "./builder.vue?vue&type=script&lang=js"
export * from "./builder.vue?vue&type=script&lang=js"
import style0 from "./builder.vue?vue&type=style&index=0&id=2094e240&prod&lang=scss&scoped=true"
import style1 from "./builder.vue?vue&type=style&index=1&id=2094e240&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2094e240",
  null
  
)

export default component.exports